import { useParams } from "react-router-dom";

import AppsView from "../views/AppsView/AppsView";

export default function Apps() {
	const { channel } = useParams();

	return <AppsView channel={channel} />;
}
